import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Modal } from "@mantine/core";
import { useMemo } from "react";
import { useLinkPatientRecordsModal } from "./use-link-patient-records-modal";
import { ModalHeader } from "./modal-header";
import { ModalFooter } from "./modal-footer";
import { CheckboxWrapper } from "./checkbox-wrapper";
import { ReportItem } from "@/components/report-item";
import { AppointmentItem } from "./appointment-item";
import { EncounterItem } from "./encounter-item";
import { InfiniteScroll } from "./infinite-scroll";
import { ResourceTab } from "./types";
/** Full-screen modal for linking patient records (reports, appointments, encounters) to a task. */
export function LinkPatientRecordsModal(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    onLink = _ref.onLink,
    linkedRes = _ref.linkedRes,
    initialTab = _ref.initialTab;
  var _useLinkPatientRecord = useLinkPatientRecordsModal({
      onClose: onClose,
      onLink: onLink,
      linkedRes: linkedRes,
      show: show,
      initialTab: initialTab
    }),
    activeTab = _useLinkPatientRecord.activeTab,
    onTabChange = _useLinkPatientRecord.onTabChange,
    linkedResources = _useLinkPatientRecord.linkedResources,
    onToggleSelection = _useLinkPatientRecord.onToggleSelection,
    selectedCount = _useLinkPatientRecord.selectedCount,
    rawTabs = _useLinkPatientRecord.tabs,
    handleCancel = _useLinkPatientRecord.handleCancel,
    handleLink = _useLinkPatientRecord.handleLink,
    isLinkDisabled = _useLinkPatientRecord.isLinkDisabled,
    reports = _useLinkPatientRecord.reports,
    onApplyTag = _useLinkPatientRecord.onApplyTag,
    applyingTagId = _useLinkPatientRecord.applyingTagId,
    appointments = _useLinkPatientRecord.appointments,
    encounters = _useLinkPatientRecord.encounters,
    onLoadMoreEncounters = _useLinkPatientRecord.onLoadMoreEncounters,
    hasNextEncountersPage = _useLinkPatientRecord.hasNextEncountersPage,
    isFetchingNextEncountersPage = _useLinkPatientRecord.isFetchingNextEncountersPage;
  var tabs = useMemo(function () {
    return rawTabs.map(function (tab) {
      switch (tab.id) {
        case ResourceTab.REPORTS:
          return _objectSpread(_objectSpread({}, tab), {}, {
            count: reports.length
          });
        case ResourceTab.APPOINTMENTS:
          return _objectSpread(_objectSpread({}, tab), {}, {
            count: appointments.length
          });
        case ResourceTab.ENCOUNTERS:
          return _objectSpread(_objectSpread({}, tab), {}, {
            count: encounters.length
          });
        default:
          return tab;
      }
    });
  }, [rawTabs, reports.length, appointments.length, encounters.length]);
  return /*#__PURE__*/React.createElement(Modal, {
    opened: show,
    onClose: handleCancel,
    withCloseButton: false,
    centered: true,
    size: "60%",
    zIndex: 1200,
    padding: 0,
    classNames: {
      modal: "overflow-hidden rounded-sds-400"
    }
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    activeTab: activeTab,
    tabs: tabs,
    onClose: handleCancel,
    onTabChange: onTabChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "overflow-y-auto scrollbar-sds bg-sds-base-secondary px-6 py-5 flex flex-col gap-4 h-[50vh]"
  }, activeTab === ResourceTab.REPORTS && /*#__PURE__*/React.createElement(InfiniteScroll, {
    hasNextPage: false,
    onLoadMore: function onLoadMore() {},
    shouldShowLoader: false
  }, reports.map(function (report) {
    var _linkedResources$repo;
    var reportId = String(report.id);
    return /*#__PURE__*/React.createElement(CheckboxWrapper, {
      key: reportId,
      id: reportId,
      isSelected: linkedResources === null || linkedResources === void 0 || (_linkedResources$repo = linkedResources.reports) === null || _linkedResources$repo === void 0 ? void 0 : _linkedResources$repo.includes(reportId),
      onToggle: function onToggle(id) {
        return onToggleSelection(id, ResourceTab.REPORTS);
      }
    }, /*#__PURE__*/React.createElement(ReportItem, {
      heading: report.heading,
      modality: report.modality,
      examDate: report.examDate,
      updatedAt: report.updated_at,
      versions: report.versions,
      onApplyTag: onApplyTag,
      applyingTagId: applyingTagId
    }));
  })), activeTab === ResourceTab.APPOINTMENTS && appointments.map(function (appointment) {
    var _linkedResources$appo;
    return /*#__PURE__*/React.createElement(CheckboxWrapper, {
      key: appointment.fhir_id,
      id: appointment.fhir_id,
      isSelected: linkedResources === null || linkedResources === void 0 || (_linkedResources$appo = linkedResources.appointments) === null || _linkedResources$appo === void 0 ? void 0 : _linkedResources$appo.includes(appointment.fhir_id),
      onToggle: function onToggle(id) {
        return onToggleSelection(id, ResourceTab.APPOINTMENTS);
      }
    }, /*#__PURE__*/React.createElement(AppointmentItem, {
      startTime: appointment.start_time,
      status: appointment.status,
      appointmentType: appointment.appointment_type,
      practitioners: appointment.practitioners.flatMap(function (p) {
        return p.display ? [p.display] : [];
      }).join(", "),
      serviceCategory: appointment.service_category,
      location: appointment.location,
      reason: appointment.reason,
      description: appointment.description,
      serviceType: appointment.service_type
    }));
  }), activeTab === ResourceTab.ENCOUNTERS && /*#__PURE__*/React.createElement(InfiniteScroll, {
    hasNextPage: hasNextEncountersPage,
    onLoadMore: onLoadMoreEncounters,
    shouldShowLoader: isFetchingNextEncountersPage
  }, encounters.map(function (encounter) {
    var _linkedResources$enco;
    return /*#__PURE__*/React.createElement(CheckboxWrapper, {
      key: encounter.fhir_id,
      id: encounter.fhir_id,
      isSelected: linkedResources === null || linkedResources === void 0 || (_linkedResources$enco = linkedResources.encounters) === null || _linkedResources$enco === void 0 ? void 0 : _linkedResources$enco.includes(encounter.fhir_id),
      onToggle: function onToggle(id) {
        return onToggleSelection(id, ResourceTab.ENCOUNTERS);
      }
    }, /*#__PURE__*/React.createElement(EncounterItem, {
      encounter: encounter
    }));
  }))), /*#__PURE__*/React.createElement(ModalFooter, {
    selectedCount: selectedCount,
    onCancel: handleCancel,
    onLink: handleLink,
    isLinkDisabled: isLinkDisabled
  }));
}